import CustomDropdownMenu from "../../../../components/CustomDropdownMenu/CustomDropdownMenu";

export const NOT_USED_VALUE = "__not_used__";
export const NOT_USED_LABEL = "Not used — skip this field";

// Fully controlled by `mapping` (the value from localMapping):
//   undefined            -> nothing selected yet
//   "none"               -> field intentionally not used
//   { model, field, .. } -> mapped to a HubSpot property
// "Not used" lives inside the picker as the first category, so one control
// covers the whole decision for a field.
export const HsModelFieldPicker = ({
  fieldsMap = {},
  pipelines = [],
  mapping,
  onChange,
  disabled = false,
  pipelineRequired = false,
}) => {
  const models = Object.keys(fieldsMap);
  const isNotUsed = mapping === "none";
  const selectedModel = (!isNotUsed && mapping?.model) || "";
  const selectedField = (!isNotUsed && mapping?.field) || "";
  const selectedPipelines = (!isNotUsed && mapping?.pipelines) || [];

  const fieldCategories = {
    "Not used": [{ value: NOT_USED_VALUE, label: NOT_USED_LABEL }],
  };
  models.forEach((model) => {
    if (Array.isArray(fieldsMap[model])) {
      fieldCategories[model] = fieldsMap[model].map((field) => ({
        value: field.name,
        label: field.label,
      }));
    }
  });

  const pipelineCategories = {
    "Available Pipelines": Array.isArray(pipelines)
      ? pipelines.map((pipeline) => ({
          value: pipeline.id,
          label: pipeline.label,
        }))
      : [],
  };

  const handleFieldSelection = (selectedValues) => {
    const value = selectedValues[0];

    if (!value) {
      onChange(undefined);
      return;
    }
    if (value === NOT_USED_VALUE) {
      onChange("none");
      return;
    }

    const model = models.find((m) =>
      fieldsMap[m]?.some((field) => field.name === value),
    );
    onChange({
      model,
      field: value,
      ...(pipelineRequired && selectedPipelines.length > 0
        ? { pipelines: selectedPipelines }
        : {}),
    });
  };

  const handlePipelineChange = (selectedIds) => {
    if (isNotUsed || !selectedField) return;

    const pipelineId = selectedIds[0] || "";
    const { pipelines: _removed, ...rest } = mapping;
    onChange(pipelineId ? { ...rest, pipelines: [pipelineId] } : rest);
  };

  const getFieldTitle = () => {
    if (isNotUsed) return "Not used";
    if (selectedModel && selectedField) {
      const fieldObj = fieldsMap[selectedModel]?.find(
        (f) => f.name === selectedField,
      );
      return `${selectedModel}: ${fieldObj?.label ?? selectedField}`;
    }
    return "Select Model & Field";
  };

  const selectedItems = isNotUsed
    ? [NOT_USED_VALUE]
    : selectedField
      ? [selectedField]
      : [];

  return (
    <div className="flex w-96 flex-col gap-2">
      <CustomDropdownMenu
        title={getFieldTitle()}
        categories={fieldCategories}
        selectedItems={selectedItems}
        onSelectionChange={handleFieldSelection}
        placeholder="Search models and fields..."
        maxHeight="400px"
        maxWidth="500px"
        disabled={disabled}
        allowMultiple={false}
        showClearButton={true}
      />

      {pipelineRequired && !isNotUsed && (
        <CustomDropdownMenu
          title={
            (Array.isArray(pipelines) &&
              pipelines.find((p) => p.id === selectedPipelines[0])?.label) ||
            "Select Pipeline"
          }
          categories={pipelineCategories}
          selectedItems={selectedPipelines}
          onSelectionChange={handlePipelineChange}
          placeholder="Search pipelines..."
          maxHeight="400px"
          maxWidth="500px"
          disabled={disabled}
          allowMultiple={false}
          showClearButton={true}
        />
      )}
    </div>
  );
};
